/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undef */
import React, { Ref } from "react";
import { VirtuosoHandle, Virtuoso } from "react-virtuoso";
import { FlatNode } from "../helpers/virtual-scrolling-helpers";
import { NodeComponent, GetInteractivity } from "../types/component-types";
import { TreeBrowserNode } from "../types/data-types";

export interface VirtualScrollingComponentProps<TNode extends TreeBrowserNode, TExtraProps extends any = undefined> {
    handleHeightChange: (height: number) => void;
    virtuosoRef: Ref<VirtuosoHandle>;
    nodeFlatTree: FlatNode<TNode>[];
    createFooter: () => JSX.Element;
    components: Partial<{ [key in TNode["type"]]: NodeComponent<TNode, TExtraProps> }>;
    extraProps: TExtraProps;
    getInteractivity: GetInteractivity<TNode>;
    followOutput: "smooth" | undefined;
    disableActions?: boolean;
}

export const VirtualScrollingComponent = <TNode extends TreeBrowserNode, TExtraProps extends any = undefined>({
    handleHeightChange,
    virtuosoRef,
    nodeFlatTree,
    createFooter,
    components,
    extraProps,
    getInteractivity,
    followOutput,
    disableActions,
}: VirtualScrollingComponentProps<TNode, TExtraProps>) => (
    <Virtuoso
        ref={virtuosoRef}
        totalListHeightChanged={handleHeightChange}
        style={{ height: "100%" }}
        data={nodeFlatTree}
        increaseViewportBy={200}
        components={{ Footer: createFooter }}
        itemContent={(_, data) => {
            const NodeComponent = components[data.type];
            return (
                <NodeComponent
                    disableActions={disableActions}
                    key={data.id}
                    node={data}
                    expanded={false}
                    extraProps={extraProps}
                    getInteractivity={getInteractivity}
                    parentNodeType={data.parentType}
                />
            );
        }}
        followOutput={followOutput}
    />
);
